module.exports = __webpack_public_path__ + "static/media/003.6a2570a1.jpg";